import { Provider } from '@angular/core';
import { MODAL_REGISTRY } from '@features/modals/modal-registry.token';
import { WithdrawSentModalComponent } from '@features/withdraw/withdraw-sent-modal/withdraw-sent-modal.component';

export function provideWithdrawModals(): Provider[] {
  return [
    { provide: MODAL_REGISTRY, useValue: { key: 'WithdrawSentModal', component: WithdrawSentModalComponent }, multi: true },
  ];
}
